<script lang="ts">
  import { onMount } from 'svelte';
  import { ActionType, useDispatch } from './Store';

  const dispatch = useDispatch();

  let vid: HTMLVideoElement;

  const handleClose = () => {
    vid.pause();
    dispatch({ type: ActionType.toggleVideo });
  };

  onMount(() => vid.play());
</script>

<div class="modal" id="videoModal" tabindex="-1" role="">
  <div class="modal-dialog modal-lg maxWidth" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <div class="card card-signup card-plain">
          <div class="modal-header">
            <div class="card-header card-header-rose text-center size">
              <button type="button" class="close" aria-hidden="true" on:click={() => handleClose()}>
                <i class="material-icons">clear</i>
              </button>
              <h4 class="card-title">Video&nbsp;zur&nbsp;App</h4>
              <div class="social-line" />
            </div>
          </div>
          <div class="modal-body">
            <video
              bind:this={vid}
              preload="metadata"
              id="video"
              width="100%"
              height="auto"
              controls
              src="https://cdn.jwplayer.com/videos/jCrwhArA-L8vacHUe.mp4"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<style>
  .modal {
    display: unset;
    background-color: rgba(0, 0, 0, 0.5);
  }
  .maxWidth {
    max-width: 896px !important;
  }

  .size {
    width: 240px;
    margin: -55px auto !important;
  }
</style>
